import { Bar, BarChart, CartesianGrid, LabelList, Tooltip, XAxis, YAxis } from "recharts";
import { formatCompactCurrency, formatCurrency } from "@/lib/calculators";
import { CHURN_MRR } from "./exampleData";
import {
  BORDER,
  CHART_NEGATIVE,
  MUTED_FG,
  tooltipStyle,
  xAxisProps,
  yAxisProps,
} from "./chartTheme";
import MetricChartFrame from "./MetricChartFrame";

/**
 * Churn MRR by month — the recurring revenue lost when customers cancel outright.
 * A loss (the app's negative red), landing on the running example's $1,200 month.
 */
const ChurnMrrChart = () => (
  <MetricChartFrame
    caption="Churn MRR swings between $900 and $1,600 a month as customers cancel outright. When it runs higher than new plus expansion MRR, the business is shrinking."
    breakdown="No breakdown"
    active="6M"
  >
    <BarChart data={CHURN_MRR} margin={{ top: 16, right: 8, left: 8, bottom: 0 }}>
      <CartesianGrid strokeDasharray="3 3" stroke={BORDER} vertical={false} />
      <XAxis dataKey="label" {...xAxisProps} />
      <YAxis tickFormatter={(v) => formatCompactCurrency(Number(v))} width={52} {...yAxisProps} />
      <Tooltip
        cursor={{ fill: "hsl(var(--muted) / 0.4)" }}
        contentStyle={tooltipStyle}
        formatter={(value: number) => [formatCurrency(value), "Churn MRR"]}
      />
      <Bar dataKey="value" fill={CHART_NEGATIVE} radius={[4, 4, 0, 0]} isAnimationActive={false}>
        <LabelList
          dataKey="value"
          position="top"
          formatter={(v: number) => formatCompactCurrency(Number(v))}
          fontSize={11}
          fill={MUTED_FG}
        />
      </Bar>
    </BarChart>
  </MetricChartFrame>
);

export default ChurnMrrChart;
